<template>
  <div class="wrapper">
    <div id="app" class>
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
    </div>
  </div>
</template>
<script>
export default {
  components: {}
};
</script>
<style lang="scss">
@import 'styles/layout/grid.scss';
</style>
